const AncillariesTracking = require('../../../../../webapp/static-content/_versionedByRelease_/js/tracking/bags_and_seats/tracking_base');
const tracking = require('../../../../../webapp/static-content/_versionedByRelease_/js/tracking/bags_and_seats/hand_luggage_tracking').getInstance();
const TRIP_TYPE = {
    'ONE_WAY': 'OW',
    'ROUND_TRIP': 'RT',
    'MULTIPLE_DESTINATIONS': 'MD',
};
const INFO = 'priority';
const TRACKING_NAME = 'hand-luggage';

const track = {
    onProductInfo() {
        const tripType = Odigeo._.get(this.bookingInfo, 'itineraryBookings.bookingItinerary.tripType');
        const travellers = Odigeo._.get(this.bookingInfo, 'travellers', []);
        return {
            name: TRACKING_NAME,
            meta: +Odigeo.SessionScope.isMeta,
            type: TRIP_TYPE[tripType],
            prov: AncillariesTracking.getProviderFromBookingInfo(this.bookingInfo),
            totpax: travellers.length,
            info: INFO,
        };
    },
};

export default {
    getTrackingData(event) {
        return {
            tracking,
            params: track[event].call(this),
        };
    },
};
